import { render, staticRenderFns } from "./casinoLayout.vue?vue&type=template&id=3c87258e&"
import script from "./casinoLayout.vue?vue&type=script&lang=js&"
export * from "./casinoLayout.vue?vue&type=script&lang=js&"
import style0 from "./casinoLayout.vue?vue&type=style&index=0&id=3c87258e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports